import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import * as styles from './FreshPromoCard.css';

interface IFreshPromoCardProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  additionalPromoList?: React.ReactNode;
  onClick?(): void;
}

export const FreshPromoCard: React.FC<IFreshPromoCardProps> = ({
  title,
  subtitle,
  backgroundImage,
  additionalPromoList,
  onClick,
}) => {
  return (
    <div className={styles['card']} style={{ backgroundImage: `url(${backgroundImage}` }} onClick={onClick}>
      <div className={styles['card-inner']}>
        <div className={styles['promo-list']}>{additionalPromoList}</div>
        <div className={styles['content']}>
          <UIText2 as="p" color="white_100">
            <span className={styles['title-text']}>{title}</span>
          </UIText2>
          <UIText2 as="p" color="white_100" fontWeight="bold">
            <span className={styles['subtitle-text']}>{subtitle}</span>
          </UIText2>
        </div>
      </div>
    </div>
  );
};
